import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Privacy from "./components/Privacy";
import Privacy2 from "./components/Privacy2";
import Privacy3 from "./components/Privacy3";
import { useEffect, useState } from "react";
import Loader from "./components/Loader";

// scrool to id


function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const scrollToElement = () => {
        const element = document.getElementById(location.hash.substring(1)); // Get the target element
        if (element) {
          element.scrollIntoView({ behavior: "smooth" }); // Smooth scroll
        } else {
          // Retry after a small delay if the element doesn't exist
          setTimeout(scrollToElement, 100);
        }
      };

      scrollToElement(); // Start checking for the element
    }
  }, [location]); // Run this effect whenever the URL changes

  return null; // This component doesn't render anything
}


function App() {

  const [loading, setLoading]= useState(true);

useEffect(() => {
  
    setTimeout(()=>{
        setLoading(false)
    },2000)


}, [])


  return (
    <div>
      <BrowserRouter>
      <ScrollToHash />
      <Routes>
        <Route exact path="/" element={loading ? <Loader/> : <Home/>} />
        <Route exact path="/privacy" element={<Privacy/>} />
        <Route exact path="/privacy2" element={<Privacy2/>} />
        <Route exact path="/privacy3" element={<Privacy3/>} />
      </Routes>
      </BrowserRouter>
     
    </div>
  );
}

export default App;
